export const getInitialValues = () => {
  return {
    shopCodes: [],
    file: null,
    ruleType: null,
    regionId: null
  }
}
